import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function TC
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            labelBlock={'TC'}
            userConfiguration={true}
        />
    );
}
export default TC